/**
 * İhbarname taleplerinde adres alanı.
 *
 * Adres, borçlu için değil TEBLİGATIN YAPILACAĞI KİŞİ (89-1'de üçüncü şahıs) için
 * sorgulanır: getIcraTebligatTalebiAdresSorgula { kisiKurumId: <borçlu>, kayitId: <3. şahıs> }.
 *
 * Kodlar ve davranış gerçek UYAP trafiğiyle doğrulandı:
 *   docs/89-1_evrak_olusturma.har  (kişi / Mernis)
 *   docs/89-1_kurum_hazirla.har    (kurum / Mersis)
 */

export const ADRES_KODU = {
  E_TEBLIGAT: 'ADRTR00013',
  MERNIS: 'ADRTR00008',
  MERSIS: 'ADRTR00011'
};

/**
 * Sorgu cevabından talebin `adres` alanına yazılacak değeri üretir. Portal türe göre
 * farklı davranıyor:
 *
 *  - Mernis: cevaptaki `adres` her zaman boş geliyor (Mernis adresi avukata
 *    gösterilmiyor), ama kayıt vardır; portal talebe yalnızca "VAR" yazıyor.
 *      cevap {ilAdi:"AĞRI", ilceAdi:"MERKEZ", adres:""}  ->  talep adres:"VAR"
 *
 *  - Mersis: gerçek adres geliyor ve portal `adres ilceAdi / ilAdi` şablonunu uyguluyor.
 *    Mersis cevabında ilceAdi/ilAdi alanları hiç bulunmadığı için sonda "  / " artığı
 *    kalıyor; UYAP bu haliyle kabul ettiği için birebir taklit ediliyor.
 *      cevap {adres:"NİSPETİYE MAH...İSTANBUL"} -> talep adres:"NİSPETİYE MAH...İSTANBUL  / "
 *
 *  - E-Tebligat: dönen değer KEP numarası, olduğu gibi kullanılıyor.
 */
export function tebligatAdresiDegeri(cevap: any, adresKodu: string): string {
  if (adresKodu === ADRES_KODU.MERNIS)
    return 'VAR';
  if (adresKodu === ADRES_KODU.MERSIS)
    return (cevap?.adres ?? '') + ' ' + (cevap?.ilceAdi ?? '') + ' / ' + (cevap?.ilAdi ?? '');
  return cevap?.adres || '';
}

/**
 * Kayıt bulunamadığında talebe yazılacak değer. UYAP bu durumda errorCode'lu cevap
 * veriyor ve UyapRequest bunu reject'e çeviriyor (UyapRequest:210).
 */
export function tebligatAdresiYok(adresKodu: string): string {
  return adresKodu === ADRES_KODU.MERNIS ? 'YOK' : '';
}
